import { createContext, ReactNode } from 'react';

import { useForm } from 'react-hook-form';

import { FormBuilderKeyValueMap } from './hooks/useFormBuilderState';

export interface FormBuilderContextType {
  keyValues: FormBuilderKeyValueMap;
  keysIncludedInSubmitRequest: string[];
  setKeyValue: (key: string, value: string) => void;
  includeKeyInSubmitRequest: (key: string) => void;
  getFinalRequestData: () => Record<string, boolean | string>;
  hookForm: ReturnType<typeof useForm>;
}

interface FormBuilderContextProviderProps {
  children: ReactNode;
  value: FormBuilderContextType;
}

export const FormBuilderContext = createContext({} as FormBuilderContextType);

export const FormBuilderContextProvider = ({
  children,
  value,
}: FormBuilderContextProviderProps) => {
  return <FormBuilderContext.Provider value={value}>{children}</FormBuilderContext.Provider>;
};
